import * as React from "react";
import { default as MuiTabs } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

type TabsProps = {
    defaultTab?: number;
    tabs: TabType[];
};

export type TabType = {
    label: string;
    content: JSX.Element;
};

export const Tabs: React.FC<TabsProps> = ({ defaultTab = 0, tabs }) => {
    const [value, setValue] = React.useState(defaultTab);

    const handleChange = (_: any, newValue: React.SetStateAction<number>) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <MuiTabs value={value} onChange={handleChange}>
                    {tabs.map((tab, idx) => (
                        <Tab label={tab.label} key={"tab" + idx} />
                    ))}
                </MuiTabs>
            </Box>

            {tabs.map((tab, idx) => (
                <TabPanel value={value} index={idx} key={"tabcontent" + idx}>
                    {" "}
                    {tab.content}{" "}
                </TabPanel>
            ))}
        </Box>
    );
};

type TabPanelProps = {
    children: React.ReactNode;
    index: number;
    value: number;
};

const TabPanel: React.FC<TabPanelProps> = (props: any) => {
    const { children, value, index } = props;

    return (
        <div hidden={value !== index}>
            {value === index && <Box sx={{ p: 3 }}> {children} </Box>}
        </div>
    );
};
